import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { UserDetails } from '../../util/constants';


@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

constructor(private http: HttpClient) { }

getAllUsers(): Observable<{success: boolean, data: UserDetails[]}>{
  return this.http.get<{success: boolean, data: UserDetails[]}>(`${environment.user_management_api_url}${API_ROUTES.ADMIN}`)
}
getUserDetails(id:string): Observable<{success: boolean, data: UserDetails}>{
  return this.http.get<{success: boolean, data: UserDetails}>(`${environment.user_management_api_url}${API_ROUTES.ADMIN}/${id}`)
}
userExists(email:string): Observable<{ exists: boolean; message: string}> {
  return this.http.get<{ exists: boolean; message: string}>(`${environment.user_management_api_url}${API_ROUTES.USER_EXISTS}?email=${email}`,) 
}
addUser(userDetails:UserDetails): Observable<{success:boolean,message:string}>{
  return this.http.post<{success:boolean,message:string}>(`${environment.user_management_api_url}${API_ROUTES.ADMIN}`,userDetails)
}
updateUser(id:string, userDetails:UserDetails):Observable<{message:string,success:boolean}>{
  return this.http.put<{message:string,success:boolean}>(`${environment.user_management_api_url}${API_ROUTES.ADMIN}/${id}`, userDetails)
}
deleteUser(id:string):Observable<{message:string,success:boolean}>{
  return this.http.delete<{message:string,success:boolean}>(`${environment.user_management_api_url}${API_ROUTES.ADMIN}/${id}`)
}
validateEmail(email: string) {
  return this.http.post<{message: string}>(`${environment.user_management_api_url}${API_ROUTES.SEND_EMAIL_VERIFICATION_CODE}`, {
    email
  });
}
validateVerificationCode(email: string, verificationCode: string) {
  return this.http.post<boolean>(`${environment.user_management_api_url}${API_ROUTES.VALIDATE_VERIFICATION_CODE}`, {
    email,
    verificationCode
  });
}
}
